import React from "react";
import { Link } from "react-router-dom";

const P = ({ children, style }) => (
  <p style={{ color: "#CCCCCC", marginBottom: 16, lineHeight: 1.7, ...style }}>{children}</p>
);

const PrivacyPage = () => (
  <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", background: "#000000", color: "#FFFFFF", lineHeight: 1.8, minHeight: "100vh" }}>

    <header style={{ textAlign: "center", padding: "40px 0", borderBottom: "1px solid #333333" }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "0 20px" }}>
        <div style={{ fontSize: 60, marginBottom: 10 }}>💪</div>
        <h1 style={{ fontSize: 36, fontWeight: 900, letterSpacing: 3, marginBottom: 10 }}>BEDRELY</h1>
        <Link to="/" style={{ color: "#6366f1", textDecoration: "none", fontSize: 14, display: "inline-block", marginTop: 20 }}>
          ← Back to Home
        </Link>
      </div>
    </header>

    <div style={{ maxWidth: 700, margin: "0 auto", padding: "60px 20px" }}>
      <h1 style={{ fontSize: 36, fontWeight: 900, marginBottom: 12 }}>Privacy Policy</h1>
      <P style={{ fontStyle: "italic", color: "#888888" }}>Effective Date: February 22, 2026</P>

      <P>
        Bedrely ("we", "us") provides a workout timer and tracking app. This policy explains how we handle your data.
      </P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>What We Collect</h2>
      <P>
        <strong style={{ color: "#fff" }}>Account info:</strong> When you sign in with Google, we receive your name, email, and profile picture.
      </P>
      <P>
        <strong style={{ color: "#fff" }}>Workout data:</strong> Workouts, exercises, goals, durations, and timestamps you create or log.
      </P>
      <P>
        <strong style={{ color: "#fff" }}>Usage & analytics:</strong> We use Firebase Analytics to understand how the app is used. This may include device type, OS, and interaction data.
      </P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>Advertising</h2>
      <P>
        We use Google AdSense to display ads. Google may use cookies and similar technologies to serve ads based on your
        prior visits to this or other websites. You can opt out of personalized advertising at{" "}
        <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" style={{ color: "#6366f1" }}>Google Ad Settings</a>.
        For more information, see{" "}
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" style={{ color: "#6366f1" }}>How Google Uses Information from Sites That Use Our Services</a>.
      </P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>How We Use Your Data</h2>
      <P>
        We use your data to provide the app, track your progress, and improve the service. We do not sell your personal information.
      </P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>Third-Party Services</h2>
      <P>
        We rely on <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#6366f1" }}>Firebase</a> (authentication, database, analytics),{" "}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#6366f1" }}>Google Sign-In</a>, and{" "}
        <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" style={{ color: "#6366f1" }}>Google AdSense</a>.
        These services have their own privacy policies.
      </P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>Your Rights</h2>
      <P>
        You can access your data in the app at any time. To request deletion of your account and data, contact us at{" "}
        <a href="mailto:support@bedrely.app" style={{ color: "#6366f1" }}>support@bedrely.app</a>.
      </P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>Children</h2>
      <P>This app is not intended for children under 13. We do not knowingly collect data from children under 13.</P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>Changes</h2>
      <P>We may update this policy and will post changes here with an updated effective date.</P>

      <h2 style={{ fontSize: 24, fontWeight: 700, margin: "36px 0 16px", color: "#6366f1" }}>Contact</h2>
      <P>
        <a href="mailto:support@bedrely.app" style={{ color: "#6366f1" }}>support@bedrely.app</a>
      </P>

      <hr style={{ border: "1px solid #333333", margin: "40px 0" }} />
      <P style={{ fontSize: 14, color: "#888888" }}>
        Last updated February 22, 2026.
      </P>
    </div>

    <footer style={{ textAlign: "center", padding: "40px 0", borderTop: "1px solid #333333", color: "#666666", fontSize: 14 }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "0 20px" }}>
        <p>&copy; 2026 Bedrely. All rights reserved.</p>
      </div>
    </footer>
  </div>
);

export default PrivacyPage;
